import { Trans } from '@lingui/macro'
import React from 'react'
import { InputField } from 'webbook-airways'

export default function InputFieldAddress(props) {
  return (
    <InputField
      autoComplete="new-password"
      label={<Trans>Address</Trans>}
      {...props}
    />
  )
}
